import styled from 'styled-components';
import { ReactComponent as RawLogoColoredSVG } from '../../../../assets/icons/logo_colored.svg';

export const IconLogoColored = styled(RawLogoColoredSVG)`
  cursor: pointer;
`;
